<div class="shift-compliance-container">
	<div
		class="
			d-flex
			flex-column flex-lg-row
			justify-content-between
			align-items-center
		"
	>
		<img
			class="shift-compliance-left"
			src="../assets/img/nextgen-tech.svg"
			alt=""
		/>

		<div class="shift-compliance-right">
			<h1 class="shift-compliance-header">
				A Next Generation <br class="d-none d-sm-block" />
				Technology for Re-<br class="d-none d-sm-block" />Imagining
				Compliance
			</h1>
			<p class="shift-compliance-para mt-4">
				Rely on our easy to deploy, infinitely scalable, and
				<br class="d-none d-sm-block" />
				universally integratable platform.
			</p>
		</div>
	</div>
</div>
